import React, { useState, useContext, useEffect, useRef } from 'react';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Subtitle2, Title3, Body1, Caption1, Subtitle1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Image, Card, InfoLabel, ButtonProps, Tooltip, Link, Textarea, ToggleButton } from "@fluentui/react-components";
import { Info20Regular, Open20Regular, GroupList20Regular, TrayItemRemove20Filled, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize20Regular, Dismiss16Regular, DismissSquare24Filled, FilterAdd20Filled, Info20Filled, Delete20Regular, AddSquare20Regular, Info16Filled } from "@fluentui/react-icons";
import { fullscreenIcon, lightTheme, messageTheme, primaryIcon, exitIcon, secondaryIcon, overflowDivider, buttonContent, inputFieldCSS, dividerWidthStyle, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, DateRanger, buttonDisabled, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../../styles/customStyles";
import { DefaultButton, Label, PrimaryButton, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../../utility/utils";
import { Breadcrumbs } from '../../../components/breadcrumbs/breadcrumbs.component';
import { SideMenu } from '../../../components/side_menu/inline_side_menu.component';
import { OverflowSetCustomExample } from '../../../components/side_menu/overFlowSet.component';
import { SearchBar } from '../../../components/searchbar/searchbar.component';
import { MenuDropdown } from '../../../components/dropdown/menu.component';
import { DropdownComponent } from '../../../components/dropdown/dropdown.component';
import { Pagination } from '../../../components/pagination/pagination.component';
import { ToastComponent } from '../../../components/toast/toast.component';
import { SkeletonDataTable } from '../../../components/skeleton/skeletonDataTable';
import OverLay from '../../../components/side_menu/overlay_side_menu.component';
import FullScreenButton from '../../../components/fullscreen/fullScreen.component';
import { usePermissionStore } from "../../../Store/permissionStore";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from '../../../hooks/globalContext';
import { DatepickerComponent } from '../../../components/picker/datepicker.component';
import { DataTable } from "../../../components/data_table/data_table.component";
import DialogBox from '../../../components/dialog/dialog.component';
import { InfoBar } from '../../../components/infoBar/infoBar.component';
import { CSVLink } from 'react-csv';
import { CensusData, CheckboxState } from "../../../interfaces/devices/census_interface";
import { DateComponent } from '../dateComponent';
import Event_func from './event_func';
import { Form } from '@rjsf/fluent-ui';
import validator from '@rjsf/validator-ajv8';
import { CustomWidgets } from '../../../components/form-components';
import { Asset_event_func } from '../asset/asset_event_func';
import { link } from 'fs';
import { SearchPages } from '../../../components/side_menu/InlineSidenav';

const Event = () => {
    const { permissions } = usePermissionStore();
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    var tenantName = contextValue.tenantName;
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');

    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [isOverlayFilter, setIsOverlayFilter] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [errorToast, setErrorToast] = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [final_data, set_final_data]: any = useState<CensusData[] | null>(null);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [searchVal, setSearchVal] = useState("");
    const [overLayData, setOverLayData] = useState<any>({});
    const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPageNo, setCurrentPageNo] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [tableData, setTableData] = useState([]);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [selectedTableData, setSelectedTableData] = useState([]);
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [troubleshooterList, setTroubleshooterList] = useState([])
    const [selectedTroubleshooterList, setSelectedTroubleshooterList] = useState([]);
    const [toastAlertError, setToastAlertError] = useState(false);
    const [toastAlertEdit, setToastAlertEdit] = useState(false)
    const [toastAlertCreate, setToastAlertCreate] = useState(false)
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [importedDataInserted, setImportedDataInserted] = useState<any>(false);
    const [jsonData, setJsonData] = useState({});
    const [uiData, setUiData] = useState({});
    const [formDataAlert, setFormDataAlert]: any = useState({});
    const [editBtnClicked, setEditBtnClicked]: any = useState(false);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [exportData, setExportData] = useState([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [toastAlertDelete, setToastAlertDelete] = useState(false)
    const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
    const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [isOsName, setOsName] = useState([]);
    const [isIconEnabled, setIconEnabled] = useState(false);
    const [rowID, setRowID]: any = useState(null);
    const [overlayName, setOverlayName] = useState('');
    const [isLatest, setIsLatest] = useState<boolean>(true);
    const [fromDate, setFromDate] = useState<Date | null>(null);
    const [toDate, setToDate] = useState<Date | null>(null);
    const [selectedAsset, setSelectedAsset]: any = useState();
    const [isDeletedata, setIsDeletedata]: any = useState(false);
    const [initialState, setInitialState] = useState(true);
    const handle = useFullScreenHandle();

    const [loadTableData, setLoadTableData] = useState(true);
    const [dartList, setDartList] = useState([]);
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [deleteAsset, setDeleteAsset]: any = useState(false);

    const [formData, setFormData]: any = useState({
        name: '',
        description: '',
        pageLimit: '',
        fromDate: '',
        toDate: ''
    });
    const formsRefs = useRef(null);

    useEffect(() => {
        if (overlayOpen) {
            const element = document.getElementById("fluent-default-layer-host");
            if (element) {
                element.style.zIndex = '9999999';
            }
        }
    }, [overlayOpen]);

    useEffect(() => {
        if (filterArray.length > 0) { setResetDisabled(false) }
    }, [filterArray]);

    // REACT JSON FORM RENDERING
    const handleNewFormChange = (e: any) => {
        setFormData({
            ...formData,
            jsonData: e.formData
        });
    }

    const handleOnCLickEdit = (val: any) => {
        setLoading(true);
        setRowID(val.id);
        setSelectedAsset(val.query);
        localStorage.setItem('selectedAssetOrEventQuery', val.query);
        contextValue.setSelectedAssetRow(val.query);

        navigate('results');
        setIsRefresh(false);
    }

    const handleEdit = (val: any) => {
        setOverlayOpen(true);
        setLoading(true);
        setRowID(val.id);
        setOverlayName('editEvent');
        const convertedJson = JSON.parse(val?.formData);
        const toDatedata = convertedJson?.toDate !== null ? new Date(convertedJson?.toDate) : null;
        const fromDate = convertedJson?.fromDate !== null ? new Date(convertedJson?.fromDate) : null;
        setFormData(convertedJson);
        setFromDate(fromDate);
        setToDate(toDatedata);
        setEditBtnClicked(true);
        if (convertedJson?.toDate) {
            setIsLatest(false);
        } else {
            setIsLatest(true);
        }
    }

    const handleAddBtnClick = () => {
        setCurrentPageNo(1);
        setOverlayName('addEvent');
        setRowID(null);
        setEditBtnClicked(false);
        setFromDate(null);
        setToDate(null);
        setIsLatest(true);
        setFormData({
            name: '',
            description: '',
            jsonData: { conditional: [{}] },
            pageLimit: '',
            fromDate: '',
            toDate: ''
        });

        setTimeout(() => {
            setOverlayOpen(true);
        }, 100);
    }

    useEffect(() => {
        if (toastAlertDelete) {
            setIsToast(true)
            setToastMessage('Event deleted successfully');
        } else {
            setToastMessage('');
            setIsToast(false)
        }
    }, [toastAlertDelete]);

    var tempTableData: any = [];
    var menuLists: any = [];

    useEffect(() => {

        final_data !== undefined && final_data !== null
            ? final_data?.map((val: any, index: any) => {
                {
                    permissions.includes("all") || permissions.includes("event_Fullaccess") ?
                        tempTableData.push({
                            id: val.id,
                            checkbox: val.status === 'Attached' ? 'hide' : 'show',
                            Query_name: { label: <Button id="ButtonHover" style={buttonContent} onClick={(e: any) => { handleEdit(val) }} appearance="transparent" size="small"> {val.name} </Button> },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1 >{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Last_asset_date_timezoned: { label: <Caption1> {val.lastModified ? convertToLocalTimezone(val.lastModified, userTimeZone) : '-'} </Caption1> },
                            Status: { label: <Button style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Result </Button> },

                        })
                        :
                        permissions.includes("event_ReadandExport") ?
                        tempTableData.push({
                            id: val.id,
                            checkbox: val.status === 'Attached' ? 'hide' : 'show',
                            Query_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.name} </Button>
                                    </Tooltip>
                            },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1 >{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            created_on_timezoned: { label: <Caption1> {convertToLocalTimezone(val.createdOn, userTimeZone)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Last_asset_date_timezoned: { label: <Caption1> {val.lastModified ? convertToLocalTimezone(val.lastModified, userTimeZone) : '-'} </Caption1> },
                            Status: { label: <Button style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Result </Button> },

                        })
                        :
                        tempTableData.push({
                            id: val.id,
                            checkbox: val.status === 'Attached' ? 'hide' : 'show',
                            // Query_name: { label: <Button id="ButtonHover" style={buttonContent} onClick={(e: any) => { handleEdit(val) }} appearance="transparent" size="small"> {val.name} </Button> },
                            Query_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.name} </Button>
                                    </Tooltip>
                            },
                            description: { label: <Caption1>{val.description}</Caption1> },
                            Create_by: { label: <Caption1 >{val.createdBy}</Caption1> },
                            created_on: { label: <Caption1> {convertUTCToReadableFormat(val.createdOn)} </Caption1> },
                            Last_asset_date: { label: <Caption1> {convertUTCToReadableFormat(val.lastModified)} </Caption1> },
                            Status: { label: <Button style={buttonContent} onClick={(e: any) => { handleOnCLickEdit(val) }} appearance="transparent" size="small"> Result </Button> },
                        })
                }
            }) : (tempTableData = []);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);
        }, 500);
    }, [final_data, permissions, formData]);

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        let name = e.target.name;
        const regexS = /^[A-Za-z ]*$/;
        const regexSN = /^[A-Za-z0-9_ ]*$/;
        const regexN = /^[0-9]*$/;

        if (name === 'filter' && dropDownValue1 === ("Query name")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Created By")) {
            if (regexN.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
        if (name === 'filter' && dropDownValue1 === ("Description")) {
            if (regexS.test(enteredValue)) {
                setDropDownValue2(enteredValue);
            }
        }
    }


    useEffect(() => {
        if (isLatest === true) {
            setFromDate(null);
            setToDate(null);
            setFormData({ ...formData, fromDate: "", toDate: "" })
        }
    }, [isLatest])

    useEffect(() => {
        setFormData({ ...formData, fromDate: fromDate, toDate: toDate })
    }, [toDate, fromDate]);

    const handleFilterArray = (): any => {
        const value1 = dropDownValue1
        const value2 = dropDownValue2;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setLoading(true);
        setDropDownValue1('');
        setDropDownValue2('');
    }

    const handleOverlayFilter = (): any => {
        const value1 = dropDownValue1Overlay;
        const value2 = dropDownValue2Overlay;
        const result = value1 + " : " + value2;
        setFilterArray([...filterArray, result])
        setIsFilter(true);
        setIsOverlayFilter(true);
        // setLoading(true);
        setDropDownValue1Overlay('');
        setDropDownValue2Overlay('');
    }

    const handleCloseFilter = (index: any): any => {
        const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
        setFilterArray(updatedArray);
        !isOverlayFilter && setLoading(true);

        setIsOverlayFilter(false);
    }

    var tableColumns: any[] = [];
    var filterColumns: any[] = [];
    useEffect(() => {
        contextValue?.tableColumnsData?.Search?.Event.forEach((val) => {
            if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
                if (val.key === "created_on_timezoned" || val.key === "Last_asset_date_timezoned") {
                    tableColumns[val.priority] = ({
                                            key: val.key,
                                            label:
                                                <>
                                                    <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                                                        <StackItem>
                                                            <Body1Strong>{`${val.name}`}</Body1Strong>
                                                        </StackItem>
                                                        <StackItem align="center">
                                                            <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                                                                <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                                                            </Tooltip>
                                                        </StackItem>
                                                    </Stack>
                                                </>
                                        });
                } else {
                    tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
                }
            }

            if (val.display.filter.toLocaleLowerCase() === "yes") {
                filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
            }
        });

        setTableColumnsData(tableColumns);
        setFilterColumnsData(filterColumns);

        contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.Search?.Event.filter((val) => val.priority >= 0));

        contextValue.setManageViewPageDetails({ module: "Search", page: "Event" });
    }, [contextValue.tableColumnsData]);

    useEffect(() => {
        var tempExportData: any = [];

        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            tempExportData.push({
                'Query Name': val.name,
                'Description': val.description,
                'Created By': (val.createdBy != undefined && val.createdBy?.length > 0) ? val.createdBy : "-",
                'Created On': convertToExcelFormat(val.createdOn),
                'Last Modified': val.modifiedOn ? convertToExcelFormat(val.modifiedOn) : "-",
            });
        });

        setExportData(tempExportData);
    }, [exportDetails]);

    useEffect(() => {
        exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    }, [exportData]);

    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                {/* <Stack tokens={{childrenGap:10}} horizontal> */}
                <StackItem>
                    {
                        permissions.includes("all") || permissions.includes("event_Fullaccess") ? (
                            <StackItem onClick={handleAddBtnClick}>
                                <Button disabled={loading} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
                                    <Stack tokens={{ childrenGap: 6 }}>
                                        {/* <StackItem><Text></Text></StackItem> */}
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <StackItem> {loading ? <AddSquare20Regular {...secondaryIcon} /> : <AddSquare20Regular {...primaryIcon} />} </StackItem> </StackItem>
                                                <StackItem> <Caption1> Create Event Query </Caption1> </StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </StackItem>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> <AddSquare20Regular {...secondaryIcon} /> </StackItem>
                                                <StackItem><Caption1> Create Event Query </Caption1></StackItem>
                                            </Stack>
                                        </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }
                </StackItem>

                <StackItem> <Divider vertical /> </StackItem>

                <StackItem>
                    <DialogBox
                        headerButton={
                            <>
                                <Button appearance="transparent" size="small"
                                    disabled={isdeletedisabled ? true : false} >
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            {/* <Delete20Regular {...primaryIcon} />  */}
                                            {isdeletedisabled
                                                ? (<Delete20Regular {...secondaryIcon} />)
                                                : (<Delete20Regular {...primaryIcon} />)
                                            }
                                        </StackItem>
                                        <StackItem> <Caption1> Delete </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </>
                        }

                        content="Please confirm if you want to proceed with deleting the event."

                        footer=
                        {
                            <>
                                <Stack horizontal tokens={{ childrenGap: 10 }}>
                                    <StackItem>
                                        <Button appearance="primary" onClick={() => { setDeleteAsset(true); setLoading(true); }} size="small">Confirm</Button>
                                    </StackItem>
                                    <StackItem>
                                        <Button size="small">Cancel</Button>
                                    </StackItem>
                                </Stack>
                            </>
                        }
                    />
                </StackItem>

                <StackItem> <Divider vertical /> </StackItem>

                <StackItem>
                    <Button
                        size="small"
                        appearance="subtle"
                        disabled={loading}
                        onClick={() => {
                            setCurrentPageNo(1);
                            setIsRefresh(true);
                            setLoading(true);
                            setRefreshToast(true);
                            setLoadTableData(true);
                        }}
                    >
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>

                    {permissions.includes("all") || permissions.includes("event_Fullaccess") || permissions.includes("event_ReadandExport") ?
                        <>
                            <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_Event_List.csv`} >
                            </CSVLink>
                            <Button disabled={loading || tableData.length === 0} size="small" appearance="subtle"
                                onClick={() => { setExportBtnClicked(true); }}  >
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                                </Stack>
                            </Button>
                        </>
                        :
                        <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                            <Button appearance="subtle" size="small" disabled>
                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem><Text></Text></StackItem>
                                    <StackItem>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                                            <StackItem><Caption1> Export </Caption1></StackItem>
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </Button>
                        </Tooltip>
                    }

                    <Button disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Manage View </Caption1> </StackItem>
                        </Stack>
                    </Button>
                </StackItem>
                {/* </Stack> */}
                {/* </Stack> */}
                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
            </>
        ,
    };


    var dataArr: any = [];
    useEffect(() => {
        contextValue.selectedRowIdInSubTable.map((val: any, i: any) => {
            dataArr.push({
                id: i,
                checkbox: "hide",
                selected: { label: <Caption1> {val} </Caption1>, id: `${i}` },
            });
        });

        dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);
        contextValue.selectedRowIdInTable.length > 0 ? setIconEnabled(true) : setIconEnabled(false);
    }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

    const handleSubmit = (e: any) => {
        e.preventDefault();
    }

    useEffect(() => {

        setOverLayData({
            size: "large",
            isTabs: true,
            headerTitle:
                (
                    <>
                        <FluentProvider theme={dashboardTheme}>
                            <Title3> Create Event Query </Title3>
                        </FluentProvider>
                    </>
                ),
            tabItems: {
                Introduction: <Stack verticalFill tokens={{ padding: '10px 0px 0px 0px' }}>
                    <form onSubmit={handleSubmit} style={dividerWidthStyle}>
                        <Stack style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: 10 }}>
                                <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                                    <p><b>Name<Image src="/Dashboard/image/required.svg" /></b></p>
                                    <Input
                                        size="small"
                                        value={formData?.name}
                                        style={inputFieldCSS}
                                        onChange={(e) => setFormData((prev: any) => ({ ...prev, name: e.target.value }))}
                                        required={true}
                                    />
                                </Stack>
                                <Stack verticalFill tokens={{ childrenGap: '8px' }} style={dividerWidthStyle}>
                                    <p><b>What is the benfit?</b></p>
                                    <Textarea
                                        size="small"
                                        value={formData?.description}
                                        onChange={(e) => setFormData((prev: any) => ({ ...prev, description: e.target.value }))}
                                        required={true}
                                    />
                                </Stack>
                            </Stack>
                            <InfoBar showSpaces={true} title={"These details will make it easy to find the snippets later when you need to use them."} />
                            <Stack style={formData.name !== "" ? { display: 'none' } : { ...buttonDisabled }}> <Button appearance="primary"
                                size="small" type='submit'>Next</Button>
                            </Stack>
                            <Stack verticalFill tokens={{ childrenGap: 10 }}>
                                <StackItem> <p><b> What is the benefit? </b></p> </StackItem>
                                <StackItem><Body1 align='justify'>Nanoheal event queries provide valuable insights into system performance by capturing data on memory usage, CPU usage, network usage, boot usage, and issue resolution details. These queries help monitor resource consumption, detect performance bottlenecks, and ensure optimal system functionality. They also track how issues are resolved, allowing for more efficient troubleshooting and faster resolution times. By analyzing these events, you can proactively manage system health, identify potential problems early, and maintain a smoother user experience with minimal disruptions.</Body1></StackItem>
                            </Stack>
                        </Stack>
                    </form>
                </Stack>
                ,
                "Configure": <Stack >
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for events. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: 20 }} style={dividerWidthStyle}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }} style={dividerWidthStyle}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                    <Form id="SearchForm" ref={formsRefs} formData={formData.jsonData} schema={jsonData} uiSchema={uiData} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
                                </Stack>
                                <StackItem verticalFill>
                                    <Label>Limit</Label>
                                    <Input
                                        required
                                        size="medium"
                                        style={{ width: '40%' }}
                                        type='number'
                                        value={formData?.pageLimit}
                                        onChange={(e: any) => setFormData({ ...formData, pageLimit: e.target.value })}
                                    />
                                    <Stack>
                                        <Caption1>"LIMIT" defines the number of events to display in the query results.</Caption1>
                                    </Stack>
                                </StackItem>
                            </Stack>
                            <Stack tokens={{ childrenGap: '10' }}>
                                <DateComponent setIsLatest={setIsLatest} isLatest={isLatest} latest={isLatest ? "latest" : "range"} />
                                {isLatest !== true ? (
                                    <Stack verticalFill tokens={{ childrenGap: '10' }} style={DateRanger}>
                                        <Stack>
                                            <Label>Date Range</Label>
                                            <Caption1>A date range refers to a specific period between two dates, within which the query results should be displayed.</Caption1>
                                        </Stack>
                                        <Stack horizontal style={dividerWidthStyle}>
                                            <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '50%' }}>
                                                <Body1Strong>From</Body1Strong>
                                                <Stack >
                                                    <DatepickerComponent setDropDownValue2={setFromDate} dropDownValue2={fromDate} maxDate={true} />
                                                </Stack>
                                            </Stack>
                                            <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '50%' }}>
                                                <Body1Strong>To</Body1Strong>
                                                <Stack >
                                                    <DatepickerComponent setDropDownValue2={setToDate} dropDownValue2={toDate} maxDate={true} />
                                                </Stack>
                                            </Stack>
                                        </Stack>
                                    </Stack>) : (<Stack></Stack>)}
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>,
                "Review and Create": <Stack>
                    <InfoBar showSpaces={true} title={"Choose the filter criteria to search for events. Specify the starting date (From Date) for the search. To perform a real-time query, leave the To Date field blank. If no To Date is selected, the query will continuously update with new data as it becomes available."} />
                    <Stack verticalFill tokens={{ childrenGap: '20' }}>
                        <Stack verticalFill tokens={{ childrenGap: '20' }}>
                            <Stack verticalFill tokens={{ childrenGap: '20' }}>
                                <Stack>
                                    <Form disabled id="SearchForm" ref={formsRefs} formData={formData.jsonData} schema={jsonData} uiSchema={uiData} validator={validator} widgets={CustomWidgets} onChange={(e) => handleNewFormChange(e)} />
                                </Stack>
                                <StackItem verticalFill>
                                    <Label>Limit</Label>
                                    <Input
                                        required
                                        disabled
                                        size="medium"
                                        style={{ width: '40%' }}
                                        placeholder='Limit'
                                        type='number'
                                        value={formData.pageLimit}
                                        onChange={(e: any) => setFormData({ ...formData, pageLimit: e.target.value })}
                                    />
                                    <Stack>
                                        <Caption1>"LIMIT" defines the number of events to display in the query results.</Caption1>
                                    </Stack>
                                </StackItem>
                            </Stack>
                        </Stack>
                        <Stack tokens={{ childrenGap: '10' }}>
                            <DateComponent setIsLatest={setIsLatest} isLatest={isLatest} latest={isLatest ? "latest" : "range"} disabled={true} />
                            {isLatest !== true ? (
                                <Stack verticalFill tokens={{ childrenGap: '10' }} style={DateRanger}>
                                    <Stack>
                                        <Label>Date Range</Label>
                                        <Caption1>A date range refers to a specific period between two dates, within which the query results should be displayed.</Caption1>
                                    </Stack>
                                    <Stack horizontal style={dividerWidthStyle}>
                                        <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '50%' }}>
                                            <Body1Strong>From</Body1Strong>
                                            <Stack >
                                                <DatepickerComponent disabled setDropDownValue2={setFromDate} dropDownValue2={fromDate} maxDate={true} />
                                            </Stack>
                                        </Stack>
                                        <Stack verticalFill tokens={{ childrenGap: '8' }} style={{ width: '50%' }}>
                                            <Body1Strong>To</Body1Strong>
                                            <Stack >
                                                <DatepickerComponent disabled setDropDownValue2={setToDate} dropDownValue2={toDate} maxDate={true} />
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Stack>) : (<Stack></Stack>)}
                        </Stack>
                    </Stack>
                </Stack>,
            },
        });
    }, [selectedTableData, dropDownValue1Overlay, dropDownValue2Overlay, filterArray, isfilter, isLatest, jsonData, formData, fromDate, toDate]);

    useEffect(() => {
        searchVal.length === 0 && !loadTableData && setLoadTableData(true);
    }, [searchVal]);

    useEffect(() => {
        contextValue.selectedRowIdInTable.length > 0 ? setDeleteDisabled(false) : setDeleteDisabled(true);
    }, [contextValue.selectedRowIdInTable]);

    useEffect(() => {
        const pageNo = (currentPageNo - 1) * 50;

        const props = {
            func: set_final_data,
            data: final_data,
            pageNo: pageNo,
            jsonData: jsonData,
            setJsonData: setJsonData,
            uiData: uiData,
            setUiData: setUiData,
            saveBtnClicked: saveBtnClicked,
            setSaveBtnClicked: setSaveBtnClicked,
            setEditBtnClicked: setEditBtnClicked,
            setToastAlertCreate: setToastAlertCreate,
            setToastAlertEdit: setToastAlertEdit,
            editBtnClicked: editBtnClicked,
            rowID: rowID,
            setRowID: setRowID,
            setOverlayName: setOverlayName,
            setToastAlertDelete: setToastAlertDelete,
            setIsDeleteAlert: setIsDeletedata,
            deleteAlert: isDeletedata,
            setTotalPages: setTotalPages,
            setTotalRecords: setTotalRecords,
            totalRecords: totalRecords,
            isRefresh: isRefresh,
            setIsRefresh: setIsRefresh,
            setExportDetails: setExportDetails,
            importedDataInserted: importedDataInserted,
            searchVal: searchVal,
            setSearchVal: setSearchVal,
            setToastAlertError: setToastAlertError,
            filterArray: filterArray,
            isfilter: isfilter,
            tenant: tenantName,
            setExportBtnClicked: setExportBtnClicked,
            exportBtnClicked: exportBtnClicked,
            formData: formData,
            setFormData: setFormData,
            setTroubleshooterList: setTroubleshooterList,
            selectedTroubleshooterList: selectedTroubleshooterList,
            overlayOpen: overlayOpen,
            selectedAsset: selectedAsset,
            loadTableData: loadTableData,
            setLoadTableData: setLoadTableData,
            setDartList: setDartList,
            dartList: dartList,
            selectedRowIdInTable: contextValue.selectedRowIdInTable,
            setSelectedRowIdInTable: contextValue.setSelectedRowIdInTable,
            overlayName: overlayName,
            JsonData: jsonData,
            setErrorToast: setErrorToast,
            setToastMessage: setToastMessage,
            setOverlayOpen: setOverlayOpen,
            setIsToast: setIsToast,
            setDeleteAsset: setDeleteAsset,
            deleteAsset: deleteAsset,
            setDeleteDisabled: setDeleteDisabled,
            type: 'event',
        };

        if ((!saveBtnClicked && overlayName === '') || (!saveBtnClicked && (overlayName === 'editEvent' || overlayName === 'addEvent')) || (saveBtnClicked && overlayName !== '')) {
            Asset_event_func(props);
        }
    }, [isfilter, filterArray, importedDataInserted, /*jsonData, uiData,*/ saveBtnClicked, rowID, editBtnClicked, isRefresh, searchVal, loadTableData, dartList, selectedAsset, deleteAsset, exportBtnClicked]);

    return (
        <>

            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    <Breadcrumbs
                                        items={[
                                            {name: "Manage", link: "/home" },
                                            {name:"Search", link:"/manage/search/asset"},
                                            {name:"Event", link:"#"}
                                        ]} 
                                    /> 
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>

                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        {/* pages code starts here */}
                        <Stack style={DynamicBoxingCSS}>

                            {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                                <StackItem> <Text></Text> </StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3> Search | Event </Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack> */}
                            <FluentProvider style={parentHome} theme={dashboardTheme}>
                                <Stack style={parentHome} horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={SearchPages("Event")} />
                                    <StackItem style={DynamicBoxingCSS}>
                                        <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem style={wraperStyle}>
                                                <StackItem>
                                                    <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                        <Stack horizontal tokens={{ childrenGap: 10 }} >
                                                            <StackItem>
                                                                <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={""} searchVal={searchVal} setSearchVal={setSearchVal} disabled={loading || tableData.length === 0} />
                                                            </StackItem>
                                                            <StackItem>
                                                                <MenuDropdown open={filterMenuOpen} btn={
                                                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                            {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                            <Body1> Filter </Body1>
                                                                        </Stack>
                                                                    </MenuButton>
                                                                } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text></Text> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                                                            {dropDownValue1 === "Created By" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2} />}
                                                                            {(dropDownValue1 === "Query name" || dropDownValue1 === "Created By" || dropDownValue1 === "Description") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1}:`))}>
                                                                                        <Caption1> Apply </Caption1>
                                                                                    </Button>
                                                                                </StackItem>

                                                                                <StackItem>
                                                                                    <Button onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                        <Caption1> Cancel </Caption1>
                                                                                    </Button>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>} />
                                                            </StackItem>
                                                            <StackItem onClick={() => { setLoadTableData(true); setLoading(true); setIsOverlayFilter(false); setFilterArray([]); setIsFilter(false); setDropDownValue2Overlay(''); setResetDisabled(true); }}>
                                                                <Button appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                        <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                    </Stack>
                                                                </Button>
                                                            </StackItem>
                                                        </Stack>
                                                        {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                    </Stack>
                                                </StackItem>
                                                <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '10px 0px 0px 8px' }}>
                                                                                                        <StackItem>
                                                                                                            {filterArray.length > 0 && (
                                                                                                                <Stack horizontal wrap>
                                                                                                                    {filterArray.map((item, index) => (
                                                                                                                        <Button shape="circular" size="small">
                                                                                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                                                                <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                                                                <StackItem>
                                                                                                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                                                                                                        <StackItem><Text></Text></StackItem>
                                                                                                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                                                                    </Stack>
                                                                                                                                </StackItem>
                                                                                                                            </Stack>
                                                                                                                        </Button>
                                                                                                                    ))}
                                                                                                                </Stack>
                                                                                                            )}
                                                                                                        </StackItem>
                                                
                                                                                                        <StackItem disableShrink>
                                                                                                            {(tableData.length > 0 && !loading) && (
                                                                                                                totalRecords > 0 &&
                                                                                                                <Caption1>
                                                                                                                    Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records
                                                                                                                </Caption1>
                                                                                                            )}
                                                                                                        </StackItem>
                                                                                                    </Stack>
                                                <InfoBar showSpaces={true} title={"Explore our troubleshooting snippets for a smooth start. Pick a setup scenario, and we'll guide you through each step, handling assignments and other configurations automatically."} />
                                            </StackItem>

                                            {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                                            {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message={(!saveBtnClicked && overlayName === '' && deleteAsset) ? "Event Data Deleted Successfully" : overlayName === 'addEvent' ? "New Event Data Created Successfully" : "Event Data Edited Successfully"} footer="" />}

                                            {errorToast && (<ToastComponent setmessagebar={setErrorToast} toastIntent="error" position="top-end" title="Failed" message={toastMessage} footer="" />)}

                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                            </FluentProvider>
                        </Stack>
                        <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} saveBtnFunc={setSaveBtnClicked} isNavBtn={true} />
                    </StackItem>
                    <StackItem><Text></Text></StackItem>

                </Stack>
            </FullScreen>
        </>
    )
}

export default Event;